type Params = Record<string, unknown>

export const objectToQueryString = (params: Params): string => {
  return Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => {
      let stringValue: string

      if (value instanceof Date) {
        stringValue = value.toISOString()
      } else {
        stringValue = typeof value === 'string' ? value : String(value)
      }

      return `${encodeURIComponent(key)}=${encodeURIComponent(stringValue)}`
    })
    .join('&')
}

export const queryStringToObject = (
  queryString: string
): Record<string, unknown> => {
  const params = new URLSearchParams(queryString)

  const result: Record<string, unknown> = {}

  params.forEach((value, key) => {
    if (value === 'true' || value === 'false') {
      result[key] = value === 'true'
    } else if (value === '') {
      result[key] = ''
    } else if (!isNaN(Number(value))) {
      result[key] = Number(value)
    } else {
      result[key] = value
    }
  })

  return result
}
